<template src="./BlacklistEditor.html"></template>

<script lang="ts">
import { Blacklist } from "@/models/blacklist/Blacklist";
import { defineComponent } from "vue";
import { PropType } from "vue";

export default defineComponent({
    props: {
        blacklistModel: { type: Object as PropType<Blacklist>, required: true }
    },
    emits: ["update:blacklistModel"],
    data() {
        return {
            localBlackList: { ...this.blacklistModel }
        };
    },
    watch: {
        blacklistModel: {
            handler(newVal: Blacklist) {
                Object.assign(this.localBlackList, newVal);
            },
            deep: true
        },
        localBlackList: {
            handler(localBlackList: Blacklist) {
                this.$emit("update:blacklistModel", { ...localBlackList });
            },
            deep: true
        }
    }
});
</script>
